import { Feature } from '@/pinia/feature'
import { energy } from './energy'
import { actualEnergy } from './actualEnergy'

export const energyAnalysis: Feature = {
  name: 'energy',
  enabled: true,
  component: 'DashboardFeature',
  access: ['FEAT_ENERGY-ANALYSIS_READER'],
  title: {
    en: 'Energy analysis',
    sv: 'Energi&shy;analys'
  },
  isRoute: true,
  props: {
    icon: 'IconZap',
    showCalendar: true
  },
  children: [
    {
      name: 'filters',
      enabled: true,
      title: {
        en: 'Filters',
        sv: 'Filter'
      },
      component: 'PortfolioAnalysisFilters'
    },
    {
      name: 'data',
      enabled: true,
      title: {
        en: 'Data',
        sv: 'Data'
      },
      children: [energy, actualEnergy]
    }
  ]
}
